// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2UnL1","title":"Header_title__rMkUK","side":"Header_side__3UKOE"};